import { Box, Text } from '@nimbus-ds/components';
import { AgentAvatarIcon } from 'commons/components/AgentChat/img';
import { useTranslationCommon } from 'commons/hooks';
import './ChatLoading.scss';

/**
 * ChatLoading component displays a loading message when AI is processing
 */
function ChatLoading(): JSX.Element {
  const t = useTranslationCommon();

  return (
    <Box display="flex" alignItems="center" gap="2" mb="4">
      <AgentAvatarIcon width={30} height={30} />

      <div className="stratus--chat-loading-shimmer">
        <Text fontSize="base" fontWeight="medium" lineHeight="base">
          {t('chat.loadingThinking', 'Pensando...')}
        </Text>
      </div>
    </Box>
  );
}

export default ChatLoading;
